import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";

import { Button } from "../../UI/Button";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { CopyGenderOptionsToOtherNetworksModal } from "./CopyGenderOptionsToOtherNetworksModal";

interface IProps {
  l2Id: number;
  isDisabled?: boolean;
}

export const AddToOtherNetworksButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const handleClick = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button appearance="primary" onClick={handleClick} isDisabled={!props.l2Id || props.l2Id === 0 || isSuperAdminRead() || props.isDisabled}>
          Apply to Other Networks
        </Button>
      </ReadOnlyWrapper>
      <CopyGenderOptionsToOtherNetworksModal l2Id={props.l2Id} />
    </>
  );
};
